import { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { AppFooter } from "@/components/AppFooter";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";

const formatUpdatedAt = (value) => {
  if (!value) return "Draft policy";
  return `Last updated ${new Date(value).toLocaleDateString("en-GB")}`;
};

export default function PrivacyPolicyPage() {
  const { user } = useAuth();
  const [policy, setPolicy] = useState(null);

  useEffect(() => {
    api
      .get("/public/privacy-policy")
      .then(({ data }) => {
        setPolicy(data);
      })
      .catch((error) => toast.error(errMsg(error)));
  }, []);
  return (
    <div className="flex min-h-screen flex-col bg-muted/30">
      <header className="border-b bg-background">
        <div className="mx-auto flex h-14 max-w-4xl items-center justify-between px-4 sm:px-6">
          <Link
            className="inline-flex items-center gap-2 text-sm font-medium transition-colors hover:text-primary"
            to={user ? "/" : "/login"}
            data-testid="privacy-back-link"
          >
            <ArrowLeft className="h-4 w-4" />
            {user ? "Back to Ask Jonny" : "Back to sign in"}
          </Link>
        </div>
      </header>
      <main className="mx-auto w-full max-w-4xl flex-1 px-4 py-10 sm:px-6 sm:py-14">
        <div className="mb-8">
          <p className="text-xs font-semibold uppercase tracking-[0.16em] text-primary">
            Ask Jonny
          </p>
          <h1 className="mt-2 font-display text-4xl font-bold sm:text-5xl" data-testid="privacy-title">
            Privacy policy
          </h1>
          <p className="mt-3 text-sm text-muted-foreground" data-testid="privacy-updated-at">
            {formatUpdatedAt(policy?.updated_at)}
          </p>
        </div>
        {!policy ? (
          <div className="py-16" data-testid="privacy-loading">
            <div className="dot-pulse flex gap-1.5">
              <span />
              <span />
              <span />
            </div>
          </div>
        ) : (
          <article
            className="prose-jonny max-w-none whitespace-pre-wrap rounded-lg border bg-card p-6 text-sm leading-7 shadow-sm sm:p-9"
            data-testid="privacy-policy-content"
          >
            <ReactMarkdown>{policy.content}</ReactMarkdown>
          </article>
        )}
      </main>
      <AppFooter />
    </div>
  );
}